window.current_collection = location.pathname.split("/").at(-1);

class SubCollection extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            mainCollection: "[js-main-collection]",
            subCollectionItem: "[js-sub-collection-item]"
        };

        this.sections = {
            mainCollection: { 
                element: document.querySelector(this.selectors.mainCollection), 
                selector: this.selectors.mainCollection 
            }
        };

        this.subCollectionItems = this.querySelectorAll(this.selectors.subCollectionItem);

        this.init();
    }

    init() {
        const subscribeToggle = this.querySelector("[js-subscribe-toggle]");

        subscribeToggle?.addEventListener("change",this.handleSubscription.bind(this));
        this.subCollectionItems.forEach(subCollection => {
            subCollection.setAttribute("data-current-collection-handle", window.current_collection);
            subCollection.addEventListener("click", this.renderSectionFromFetch.bind(this))
        });

        if(document.querySelector(".section-main-collection-grid").classList.contains("is-subscription-enabled")) {
            subscribeToggle.checked = true;
        }
    }

    handleSubscription({ target }) {
        const section = document.querySelector(".section-main-collection-grid");
        if (target.checked) {
            section?.classList.add("is-subscription-enabled");
            const url = new URL(window.location);
            url.searchParams.set("subscriptions", "true");
            window.history.replaceState(null, "", url);
        } else {
            section?.classList.remove("is-subscription-enabled");
            const url = new URL(window.location);
            url.searchParams.delete("subscriptions");
            window.history.replaceState(null, "", url);
        }
    }

    renderSectionFromFetch(evt) {
        evt.preventDefault();
        const { currentTarget } = evt;
        const handle = currentTarget.classList.contains("is-active") ? currentTarget.getAttribute("data-current-collection-handle") : currentTarget.getAttribute("data-collection-handle");

        this.updateLoading();

        Object.values(this.sections).map(({ element, selector, initEvents = [] }) => {
            return element ? this.renderSection(handle, element, selector, ...initEvents) : Promise.resolve();
        });
    }

    updateURLHash(handle) {
        const url = document.querySelector(".section-main-collection-grid").classList.contains("is-subscription-enabled") ? `/collections/${handle}?subscriptions=true` : `/collections/${handle}`;
        window.history.replaceState({}, '', url);
    }

    updateLoading() {
        this.sections.mainCollection.element.classList.add("section--loading");
    }

    renderSection(handle, container, selector, ...initEvents) {
        const url = `/collections/${handle}?section_id=${container.getAttribute("data-section-id")}`;
        return this.ajaxSection(url, handle, container, selector, initEvents);
    }

    ajaxSection(url, handle, container, selector, initEvents = []) {
        return fetch(url)
            .then(response => response.text())
            .then(html => {
                const ajaxContainer = new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector(selector);

                if (ajaxContainer) {
                    container.innerHTML = ajaxContainer.innerHTML;
                };

                container.classList.remove("section--loading");
                initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));

                this.updateURLHash(handle);
            })
            .catch(err => {
                console.log(err);
            });
    }
}

customElements.define('sub-collection', SubCollection);

class ProductCardSubscription extends HTMLElement {
    constructor() {
        super();

        this.subscriptionSelect = this.querySelector("[js-subscription-select]");

        this.init();
    }

    init() {
        this.subscriptionSelect.addEventListener("change", function() {
            const productCard = this.closest(".product-card");
            const quickAddBtn = productCard.querySelector("quick-add-button");
            const selling_plan = this.value;
    
            if(quickAddBtn && selling_plan) {
                quickAddBtn.setAttribute("selling-id", selling_plan)
            }
        })
    }
}

customElements.define('product-card-subscription', ProductCardSubscription);

class ProductOption extends HTMLElement {
    constructor() {
        super();

        this.optionItems = this.querySelectorAll("[js-option-item]");

        this.init();

        document.body.className.includes("discount--") ? this.handlePriceDiscount() : null;
    }

    init() {
        this.optionItems.forEach( optionItem => optionItem.addEventListener("change", function() {
            const productCard = this.closest(".product-card");
            const featured_img = productCard.querySelector("[js-featured-image]");
            const quickAddBtn = productCard.querySelector("quick-add-button");
            const savingPriceEl = productCard.querySelector("[js-saving-price]");
            const regularPriceEls = productCard.querySelectorAll("[js-regular-price]");
            const subscriptionRegularPriceEls = productCard.querySelectorAll("[js-subscription-regular-price]");
            const subscriptionComparePriceEls = productCard.querySelectorAll("[js-subscription-compare-price]");
            const variant_id = this.value;
            const imgSrc = this.getAttribute("data-img-src");
            const regularPrice = this.getAttribute("data-product-price");
            const subscriptionRegularPrice = this.getAttribute("data-subscription-regular-price");
            const subscriptionComparePrice = this.getAttribute("data-subscription-compare-price");
            const savingPrice = this.getAttribute("data-subscription-saving");
    
            if(this.getAttribute('is') !== 'quantity' && quickAddBtn && variant_id) {
                quickAddBtn.setAttribute("variant-id", variant_id)
            };
            
            if(this.getAttribute('is') === 'quantity') {
                quickAddBtn.setAttribute("data-quantity", this.value)
            };

            if(imgSrc) {
                featured_img.setAttribute("src", imgSrc);
                featured_img.setAttribute("srcset", imgSrc);
            }

            regularPriceEls.forEach( regularPriceEl => regularPriceEl.textContent = regularPrice);

            if(subscriptionRegularPriceEls.length) {
                subscriptionRegularPriceEls.forEach( subscriptionRegularPriceEl => subscriptionRegularPriceEl.textContent = subscriptionRegularPrice);
                subscriptionComparePriceEls.forEach( subscriptionComparePriceEl => subscriptionComparePriceEl.textContent = subscriptionComparePrice);
                // savingPriceEl.textContent = `saving ${savingPrice}`;
            }
        }));
    }

    handlePriceDiscount() {
        this.optionItems.forEach( optionItem => {
            const productCard = optionItem.closest(".product-card");
            const savingBadgeEl = productCard.querySelector("[js-sale-badge]");
            const regularPrice = parseFloat(optionItem.getAttribute("data-product-price").replace(/[^0-9.]/g, ''));
            const subscriptionRegularPrice = parseFloat(optionItem.getAttribute("data-subscription-regular-price")?.replace(/[^0-9.]/g, ''));
            const subscriptionComparePrice = optionItem.getAttribute("data-subscription-regular-price");

            let discountRegularPrice;
            let discountSubscriptionRegularPrice;
            let discountPercentage;

            if(document.body.classList.contains("discount--ten")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.1)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.1)).toFixed(2);
                discountPercentage = '20%';
            }if(document.body.classList.contains("discount--fifteen")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.15)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.15)).toFixed(2);
                discountPercentage = '25%';
            }if(document.body.classList.contains("discount--twenty")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.2)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.2)).toFixed(2);
                discountPercentage = '30%';
            }if(document.body.classList.contains("discount--twenty-five")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.25)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.25)).toFixed(2);
                discountPercentage = '35%';
            }if(document.body.classList.contains("discount--thirty")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.3)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.3)).toFixed(2);
                discountPercentage = '40%';
            }if(document.body.classList.contains("discount--thirty-five")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.35)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.35)).toFixed(2);
                discountPercentage = '45%';
            }if(document.body.classList.contains("discount--fourty")) {
                discountRegularPrice = (regularPrice - (regularPrice * 0.4)).toFixed(2);
                discountSubscriptionRegularPrice = (subscriptionRegularPrice - (subscriptionRegularPrice * 0.4)).toFixed(2);
                discountPercentage = '50%';
            };

            optionItem.setAttribute("data-product-price", `$ ${discountRegularPrice}`);
            // if(optionItem.hasAttribute("data-subscription-regular-price")) {
            //     optionItem.setAttribute("data-subscription-regular-price", `$ ${discountSubscriptionRegularPrice}`);
            //     optionItem.setAttribute("data-subscription-compare-price", subscriptionComparePrice);
            //     savingBadgeEl.textContent = `ahorra ${discountPercentage}`;
            // }

            if(productCard.querySelector("[js-option-item]") === optionItem) {
                optionItem.dispatchEvent(new Event("change"));
            }
        })
    }
}

customElements.define('product-option', ProductOption);

if(location.pathname.includes("subscripciones") || location.search.includes("subscriptions=true")) {
    const subscriptionToggle =  document.querySelector("[js-subscribe-toggle]");

    subscriptionToggle.checked = true;
    subscriptionToggle.dispatchEvent(new Event("change"));
}